import {Fragment, useState} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as HomeIcon } from "../../assets/svg/home.svg";
import { ReactComponent as MeetingIcon } from "../../assets/svg/meeting.svg";
import { ReactComponent as ProfileIcon } from "../../assets/svg/profile.svg";
import { ReactComponent as ChatIcon } from "../../assets/svg/chats.svg";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ContentLoader from "react-content-loader";

export default function MobileNav(){
    const {t} = useTranslation()
    const navigate = useNavigate();
    const location = useLocation();
    const [showMessageList, setShowMessageList] = useState(false);

    const handleChatClick = (e) => {
        e.preventDefault();
        setShowMessageList(true);
    };

    const closeMessageList = () => {
        setShowMessageList(false);
    };

    const handleConversationSelect = (id, is_group) => {
        if (is_group == 0) {
            navigate("/messages/thread/" + id);
        } else {
            navigate("/messages/group/" + id);
        }
        setShowMessageList(false); // Close modal after navigation
    };

    // Get message data from Redux
    const selector = useSelector((state) => state.messageReducer);
    const InboxList = selector?.users || [];
    const strAscending = [...InboxList].sort((a, b) =>
        a.last_message_id < b.last_message_id ? 1 : -1,
    );

    return(
        <Fragment>
            <div className="d-flex justify-content-between align-items-center">
                <Link to={'/'} className="flex-grow-1 text-center mobile-bottom-nav-item">
                    <HomeIcon />
                    <p>{t('Home')}</p>
                </Link>
                <Link to={'/meeting'} className="flex-grow-1 text-center  mobile-bottom-nav-item">
                    <MeetingIcon />
                    <p>{t('Meeting')}</p>
                </Link>
                <div onClick={handleChatClick} className="flex-grow-1 text-center mobile-bottom-nav-item" style={{cursor: 'pointer'}}>
                    <ChatIcon />
                    <p>{t('Messages')}</p>
                </div>
                <Link to={'/notifications'} className="flex-grow-1 text-center  mobile-bottom-nav-item">
                    <NotificationIcon />
                    <p>{t('Notifications')}</p>
                </Link>
                <Link to={'/me'} className="flex-grow-1 text-center  mobile-bottom-nav-item">
                    <ProfileIcon />
                    <p>{t('Profile')}</p>
                </Link>
            </div>

            {/* Mobile Message List Modal */}
            {showMessageList && (
                <div className="mobile-message-modal-overlay" onClick={closeMessageList}>
                    <div className="mobile-message-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="mobile-message-modal-header">
                            <h6>{t('Messages')}</h6>
                            <button onClick={closeMessageList} className="mobile-message-close-btn">
                                <i className="fa-solid fa-times"></i>
                            </button>
                        </div>
                        <div className="mobile-message-modal-body">
                            <div className="message-people-srch">
                                <div className="messages-search-box">
                                    <form>
                                        <input
                                            type="text"
                                            className="input-search"
                                            placeholder={t('Search Contacts')}
                                        />
                                        <button type="button">
                                            <i className="fa-solid fa-magnifying-glass" />
                                        </button>
                                    </form>
                                </div>
                            </div>
                            
                            <div className="mesg-peple">
                                <ul className="messages-list">
                                    {selector.loading && (
                                        <div>
                                            <li>
                                                <div className="usr-msg-details d-flex align-items-center">
                                                    <div className="usr-ms-img flex-grow-1">
                                                        <ContentLoader
                                                            speed={3}
                                                            width={250}
                                                            height={80}
                                                            viewBox="0 0 250 80"
                                                            backgroundColor="#dfdddd"
                                                            foregroundColor="#ebebeb"
                                                        >
                                                            <circle cx="53" cy="57" r="24" className="user-picture-container rounded-circle" />
                                                            <rect x="81" y="43" rx="0" ry="0" width="327" height="8" />
                                                            <rect x="82" y="57" rx="0" ry="0" width="271" height="7" />
                                                        </ContentLoader>
                                                    </div>
                                                </div>
                                            </li>
                                        </div>
                                    )}

                                    {!selector.loading && InboxList?.length > 0 ? (
                                        strAscending?.map((value, index) => (
                                            <div key={index}>
                                                <li 
                                                    className={`${location.pathname === '/messages/thread/' + value.to_id ? 'active' : location.pathname === '/messages/group/' + value.to_id ? 'active' : ''}`} 
                                                    onClick={() => handleConversationSelect(value.to_id, value.is_group)}
                                                    style={{cursor: 'pointer'}}
                                                >
                                                    <div className="usr-msg-details d-flex align-items-center">
                                                        <div className="usr-ms-img flex-grow-1">
                                                            <div className="d-flex align-items-center">
                                                                <div
                                                                    className="user-picture-container rounded-circle"
                                                                    style={{ backgroundImage: `url(${value.image})` }}
                                                                />
                                                                <div className="usr-mg-info">
                                                                    <h3>
                                                                        {value.name}
                                                                        {value.is_group == 0 ? (
                                                                            value.is_online == '1' ? (
                                                                                <span className="ms-1 people-active ">
                                                                                    <i className="fa-solid fa-circle" />
                                                                                </span>
                                                                            ) : (
                                                                                <span className="ms-1 people-active people-inactive">
                                                                                    <i className="fa-solid fa-circle"></i>
                                                                                </span>
                                                                            )
                                                                        ) : ''}
                                                                    </h3>
                                                                    <p className={`${value.unread_count > 0 ? 'unseen-color' : ''}`}>
                                                                        {value.message?.length > 23 ? `${value.message.substring(0, 22)}...` : value.message}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="msg-seen-time">
                                                            <div className="posted_time">{value.created_at}</div>
                                                            {value.unread_count > 0 ? (
                                                                <div className="msg-notifc">{value.unread_count}</div>
                                                            ) : (
                                                                <div className="seen-unseen-icon">
                                                                    {value.seen_at != null ? (
                                                                        <i className="fa-solid fa-check-double" style={{ color: '#23d2e2' }} />
                                                                    ) : (
                                                                        <i className="fa-solid fa-check-double" />
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </li>
                                            </div>
                                        ))
                                    ) : (
                                        !selector.loading && (
                                            <div className="text-center py-4">
                                                <p className="text-muted">{t('No conversations yet')}</p>
                                            </div>
                                        )
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}